import { updateKeyInStore } from 'App';
import {
  NonUsCorpOfPartnershipStateValues,
  UpdateFieldArrayKeysKeys,
  updateKey,
} from '../slice';

export const uploadFields: IBaseField<
  keyof NonUsCorpOfPartnershipStateValues | UpdateFieldArrayKeysKeys
>[] = [
  {
    name: 'uploadACopyOfTheForm5471FiledOnYourBehalf',
    label: 'Upload a copy of the form 5471 filed on your behalf',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.income.corporationTrust.nonUsCorpOfPartnership.values.wasForm5471FiledOnYourBehalfByAnotherUsOfficerdirectorOfThisForeignCorporation',
  },
  {
    name: 'pleaseUploadDocumentShowingCoprorateDetailsDateOfIncorporationAndShareOwnershipForAllShareholders',
    label:
      'Please upload document showing coprorate details, date of incorporation, and share ownership for all shareholders',
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'pleaseUploadCorporationBalanceSheet',
    label: 'Please upload Corporation balance sheet',
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'pleaseUploadTheCorporationsIncomeStatement',
    label: "Please upload the corporation's income statement",
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    name: 'pleaseUploadLastFiledForm5471Or8865',
    label: 'Please upload last filed form 5471 or 8865',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.income.corporationTrust.nonUsCorpOfPartnership.values.haveYouFiledForm5471Or8865Before',
  },
];
